import { render } from "./Compagnies.vue?vue&type=template&id=534941c4&scoped=true"
import script from "./Compagnies.vue?vue&type=script&lang=js"
export * from "./Compagnies.vue?vue&type=script&lang=js"

import "./Compagnies.vue?vue&type=style&index=0&id=534941c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534941c4"]])

export default __exports__